import { useEffect, useRef } from 'react';
import styles from './AiSuggestionsSection.module.css';
import AlisaIcon from 'assets/icons/AlisaIcon';

function AiSuggestionsSection({ aiSuggestions, onSelect, getInputValue, selectedIndex, activeIndex }) {
    if (!aiSuggestions?.length) return null;

    return (
        <div className={styles['ai-suggestions']}>
            <div className={styles['ai-suggestions-header']}>
                <span className={styles['ai-suggestions-title']}>Latest AI suggestions</span>
            </div>
            {aiSuggestions.map((suggestion, i) => (
                <AiSuggestionItem
                    key={`${suggestion.value}-${i}`}
                    suggestion={suggestion}
                    selected={selectedIndex === i}
                    active={activeIndex === i}
                    onSelect={onSelect}
                    getInputValue={getInputValue}
                    index={i}
                />
            ))}
        </div>
    );
}

function AiSuggestionItem({ suggestion, selected, active, onSelect, getInputValue, index }) {
    const itemRef = useRef(null);

    useEffect(() => {
        if (selected && itemRef.current) {
            itemRef.current.scrollIntoView({ block: 'nearest', inline: 'start' });
        }
    }, [selected]);

    const classNames = [styles['ai-suggestion-item']];
    if (selected) classNames.push(styles['ai-suggestion-item--selected']);
    if (active) classNames.push(styles['ai-suggestion-item--active']);

    return (
        <div ref={itemRef} className={classNames.join(' ')} onMouseDown={() => onSelect(suggestion.value, index)}>
            <span className={styles['ai-suggestion-value']}>
                {typeof suggestion.value === 'object' ? getInputValue(suggestion.value) : suggestion.value}
            </span>
            <div className={styles['ai-suggestion-meta']}>
                <span className={styles['ai-suggestion-time']}>{formatTimestamp(suggestion.timestamp)}</span>
                <AlisaIcon />
            </div>
        </div>
    );
}

function formatTimestamp(timestamp) {
    const seconds = Math.round((Date.now() - timestamp) / 1000);
    if (seconds < 2) return 'now';
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    return `${Math.round(minutes / 60)}h ago`;
}

export default AiSuggestionsSection;
